import { API_BASE_URL } from '../config/api';

const API_ORIGIN = API_BASE_URL.replace(/\/api\/v1\/?$/i, '');

/**
 * URL نمایش امضای شرکت — فقط وقتی مسیر واقعاً به فایل تصویر اشاره کند.
 * پاسخ API گاهی فقط پوشه است: .../user-uploads/contract/sign (بدون نام فایل)
 */
export const getContractSignatureImageUrl = (signature) => {
  if (!signature || typeof signature !== 'string') return null;
  const raw = signature.trim();
  if (!raw) return null;

  const pathOnly = raw.split('?')[0].replace(/\/$/, '');
  if (/\/sign$/i.test(pathOnly)) return null;

  const hasImageExt = /\.(png|jpe?g|gif|webp|svg)$/i.test(pathOnly);
  const hasSignFile = /\/sign\/[^/]+\.[a-z0-9]+$/i.test(pathOnly);
  if (!hasImageExt && !hasSignFile) return null;

  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/')) return `${API_ORIGIN}${raw}`;
  if (raw.startsWith('user-uploads')) return `${API_ORIGIN}/${raw}`;
  return null;
};

export const hasContractSignature = (signature) => Boolean(getContractSignatureImageUrl(signature));

/** لینک عمومی قرارداد بر اساس hash (صفحهٔ front بک‌اند) */
export const getContractPublicUrl = (hash) => {
  if (!hash) return null;
  return `${API_ORIGIN}/account/contracts/${hash}`;
};

/** وضعیت نمایشی قرارداد */
export const resolveContractStatusLabel = (contract) => {
  if (!contract) return '—';
  if (contract.status) return String(contract.status);
  if (contract.company_sign && contract.signature) return 'امضا شده';
  if (contract.company_sign) return 'امضای شرکت';
  if (contract.signature) return 'امضای مشتری';
  return 'در انتظار امضا';
};
